import { checkNullId } from '@/shared/lib';
import _ from 'lodash';
import type { KeyboardEvent } from 'react';

/**
 * Moves focus to the next form field of the new study step 1 form when Enter is pressed. Resolves the current input's position in the supplied id list and, when both the current and next ids exist in the DOM, focuses the next element.
 *
 * @param e - Keyboard event from the focused input.
 * @param idArr - Ordered element ids describing the tab sequence.
 * @returns Nothing.
 */
const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>, idArr: string[]) => {
  const currentId = e.currentTarget.id;
  const idIndex = _.indexOf(idArr, currentId) !== -1 ? _.indexOf(idArr, currentId) : null;
  if (idIndex === null) return;
  if (e.key === 'Enter' && checkNullId(idArr[idIndex]) && checkNullId(idArr[idIndex + 1])) {
    document.getElementById(idArr[idIndex + 1])?.focus();
  }
};

export { handleKeyDown };
